import { useQuery } from '@tanstack/react-query';
import { useSearchParams } from 'react-router';
import { paymentLinkQueries } from 'receivable-invoices-js/react/api/queries/fetch-payment-link/fetch-payment-link';
import type { PaymentLink } from 'receivable-invoices-js/react/api/models/payment-link';

interface UseRouteQueryReturn {
  paymentLink?: PaymentLink;
  isLoading: boolean;
  isError: boolean;
  paymentId: string | null;
}

export function useRouteQuery(): UseRouteQueryReturn {
  const [searchParams] = useSearchParams();
  const resourceId = searchParams.get('resource_id') || '';
  const paymentId = searchParams.get('payment_id');

  const {
    data: paymentLink,
    isLoading,
    isError,
  } = useQuery({
    ...paymentLinkQueries.findItem({ resourceId }),
    enabled: Boolean(resourceId),
  });

  return {
    paymentLink,
    isLoading,
    isError,
    paymentId,
  };
}
